/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { ActionType, createAction, createAsyncAction } from "typesafe-actions";
import { Facility } from "../../db/stores/facilities";

export const getFacilities = createAsyncAction(
  "GET_FACILITIES_REQUEST",
  "GET_FACILITIES_SUCCESS",
  "GET_FACILITIES_FAILURE"
)<undefined, Facility[], Error>();

export const throttledGetFacilities = createAction('THROTTLED_GET_FACILITIES');

export const facilitiesDatabaseUpdated = createAction(
  "FACILITIES_DATABASE_UPDATED",
  action => () => action()
);

export const facilitiesDatabaseUpdateError = createAction(
  "FACILITIES_DATABASE_UPDATE_ERROR",
  action => (error: Error) => action(error)
);

/**
 * Set the current facility
 */
export const setCurrentFacilityAction = createAction(
  "SET_CURRENT_FACILITY",
  action => (facility: Facility|string|undefined) => action(facility)
);

export type FacilityActions = ActionType<typeof getFacilities>
| ActionType<typeof facilitiesDatabaseUpdated>
| ActionType<typeof facilitiesDatabaseUpdateError>
| ActionType<typeof throttledGetFacilities>
| ActionType<typeof setCurrentFacilityAction>;